import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { Formik } from 'formik';
import {
  updateUserApi,
  createSMUserApi,
  getStoresAPI
} from 'api';
import {
  Grid,
  Button,
  TextField,
  Switch
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';


const EditUser = ({userData, openDialog}) => {
  const dispatch = useDispatch();
  const { stores } = useSelector((state: IReduxState) => state.admin);

  const handleSaveUserEdits = (editedUser) => {
    const userId = userData._id;

    if (userId) {
      const userProfile = {
        firstName: editedUser.firstName,
        lastName: editedUser.lastName,
        email: editedUser.email,
        isDermproStaff: editedUser.isDermproStaff,
        stores: editedUser.stores.map((s) => s._id),
      };

      updateUserApi({dispatch, userProfile, userId});
    } else {
      createSMUserApi({dispatch, user: editedUser });
    }
  };

  const handleSearchStore = (searchValue) => {
    const params = new URLSearchParams({
      storeUrl: searchValue,
      page: '1',
      limit: '10',
    }).toString();

    getStoresAPI({dispatch, params});
  };

  return (
    <Formik
      initialValues={{
        firstName: userData.firstName ? userData.firstName : '',
        lastName: userData.lastName ? userData.lastName : '',
        email: userData ? userData.email : '',
        stores: userData.stores ? userData.stores : [],
        isDermproStaff: userData?.isDermproStaff,
      }}
      validationSchema={
        yup.object({
          firstName: yup
            .string()
            .required('Field is required'),
          lastName: yup
            .string()
            .required('Field is required'),
          email: yup
            .string()
            .email('Enter valid email')
            .required('Field is required'),
          stores: yup
            .array()
            .min(1, 'Field is required')
            .required('Field is required'),
        })}
      onSubmit={(values) => {
        handleSaveUserEdits(values);
        openDialog(false);
      }}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleSubmit,
        handleChange
      }) => (
        <form onSubmit={handleSubmit} className="p-8">
          <Grid container spacing={3}>
            <Grid item xs={12} className="mt-4 flex items-center">
              <Grid item xs={12} sm={4} md={3}>First Name:</Grid>
              <Grid item xs={12} sm={8} md={9}>
                <TextField
                  fullWidth
                  name="firstName"
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.firstName && Boolean(errors.firstName)}
                  helperText={touched.firstName && errors.firstName}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} className="mt-4 flex items-center">
              <Grid item xs={12} sm={4} md={3}>Last Name:</Grid>
              <Grid item xs={12} sm={8} md={9}>
                <TextField
                  fullWidth
                  name="lastName"
                  value={values.lastName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.lastName && Boolean(errors.lastName)}
                  helperText={touched.lastName && errors.lastName}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} className="mt-4 flex items-center">
              <Grid item xs={12} sm={4} md={3}>Email:</Grid>
              <Grid item xs={12} sm={8} md={9}>
                <TextField
                  fullWidth
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} className="mt-4 flex items-center">
              <Grid item xs={12} sm={4} md={3}>Is Dermpro staff:</Grid>
              <Grid item xs={12} sm={8} md={9}>
                <Switch
                  onChange={handleChange}
                  checked={values?.isDermproStaff}
                  color="primary"
                  name="isDermproStaff"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} className="mt-4 flex items-center">
              <Grid item xs={12} sm={4} md={3}>Stores:</Grid>
              <Grid item xs={12} sm={8} md={9}>
                <Autocomplete
                  multiple
                  fullWidth
                  disableClearable
                  value={values.stores}
                  options={stores}
                  getOptionLabel={(option) => option.storeUrl}
                  filterSelectedOptions
                  getOptionSelected={(option, value) => option._id === value._id}
                  onInputChange={(e, value) => {
                    handleSearchStore(value);
                  }}
                  onChange={(e, value) => {
                    setFieldValue('stores', value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select stores available to user"
                      error={touched.stores && Boolean(errors.stores)}
                      helperText={touched.stores && errors.stores}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
          <div className="mt-8 flex items-center justify-between">
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className="capitalize"
            >
              Save
            </Button>
            <Button
              variant="contained"
              className="capitalize"
              onClick={() => {
                openDialog(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </Formik>

  );
};

export default EditUser;
